/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_File_Pick_CancelledInputs */



/**
* | output |
* | --- |
* | "No file was selected." |
*
* @param {Canvas_File_Pick_CancelledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_file_pick_cancelled = /** @type {((inputs?: Canvas_File_Pick_CancelledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_File_Pick_CancelledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Es wurde keine Datei ausgewählt.")
	return /** @type {LocalizedString} */ ("No file was selected.")
});